/* ═══════════════════════════════════════════════════════════════════════════
   Shared UI primitives for the homepage
   ═══════════════════════════════════════════════════════════════════════════ */

export function Chip({ children, active = false }: { children: React.ReactNode; active?: boolean }) {
  return (
    <span className="inline-flex items-center justify-center px-3 py-1.5 rounded-full text-[11px] font-bold uppercase tracking-wider transition-all" style={{
      background: active ? "rgba(108,92,231,0.08)" : "#F1F5F9",
      color: active ? "var(--mc-violet)" : "var(--text-muted)",
      border: `1px solid ${active ? "rgba(108,92,231,0.15)" : "var(--border)"}`,
    }}>
      {children}
    </span>
  );
}

export function SectionDivider() {
  return <div className="gradient-line max-w-4xl mx-auto" />;
}

export function SectionHeader({ eyebrow, heading, sub, className = "" }: { eyebrow?: string; heading: string; sub?: string; className?: string }) {
  return (
    <div className={`text-center mb-20 max-w-3xl mx-auto ${className}`}>
      {eyebrow && (
        <span className="inline-flex items-center gap-2 mb-6 px-4 py-1.5 rounded-full text-[11px] font-bold uppercase tracking-wider" style={{
          background: "rgba(108,92,231,0.04)",
          color: "var(--mc-violet)",
          border: "1px solid rgba(108,92,231,0.1)",
        }}>
          <span className="w-1.5 h-1.5 rounded-full bg-[var(--mc-violet)]" />
          {eyebrow}
        </span>
      )}
      <h2 className="text-[clamp(2rem,5vw,3.8rem)] font-black tracking-tight mb-6 leading-[1.05]">
        <span className="gradient-text">{heading}</span>
      </h2>
      {sub && (
        <p className="text-[15px] md:text-[17px] text-(--text-secondary) max-w-2xl mx-auto leading-relaxed">
          {sub}
        </p>
      )}
    </div>
  );
}

export function GithubIcon({ size = 18 }: { size?: number }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor"><path d="M12 0C5.37 0 0 5.37 0 12c0 5.31 3.435 9.795 8.205 11.385.6.105.825-.255.825-.57 0-.285-.015-1.23-.015-2.235-3.015.555-3.795-.735-4.035-1.41-.135-.345-.72-1.41-1.23-1.695-.42-.225-1.02-.78-.015-.795.945-.015 1.62.87 1.845 1.23 1.08 1.815 2.805 1.305 3.495.99.105-.78.42-1.305.765-1.605-2.67-.3-5.46-1.335-5.46-5.925 0-1.305.465-2.385 1.23-3.225-.12-.3-.54-1.53.12-3.18 0 0 1.005-.315 3.3 1.23.96-.27 1.98-.405 3-.405s2.04.135 3 .405c2.295-1.56 3.3-1.23 3.3-1.23.66 1.65.24 2.88.12 3.18.765.84 1.23 1.905 1.23 3.225 0 4.605-2.805 5.625-5.475 5.925.435.375.81 1.095.81 2.22 0 1.605-.015 2.895-.015 3.3 0 .315.225.69.825.57A12.02 12.02 0 0024 12c0-6.63-5.37-12-12-12z"/></svg>;
}

export function ArrowIcon() {
  return <svg className="w-4 h-4 transition-transform group-hover:translate-x-1" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M5 12h14M12 5l7 7-7 7" /></svg>;
}
